var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("HMICare CLINIC & DIAGNOSTIC CENTER")]),_c('h4',[_vm._v(" An affiliate clinic contracted by HMI to provide medical care and services to HMI Members. ")])])
}]

export { render, staticRenderFns }